/**
 * Created by Ella on 05/15/2020.
 * Description:
 *
 * ---------maintenance history-------------
 */

import { Component, OnInit, ChangeDetectorRef, Input, OnDestroy, HostListener, ElementRef } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Subscription, Subject, Observable } from 'rxjs';
import { skip, take, map, filter } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { ColDef, GridOptions } from 'ag-grid-community';
import * as _ from 'lodash';
import { FileHelperService } from '../../../services/file-helper.service';
import { DateHelperWebService } from '../../../tamalelibs/services/date-helper.web.service';
import { DELETE_SIDENOTE_SUCCESS, DELETE_ATTACHMENT_SUCCESS } from '../../../tamalelibs/redux/note.actions';
import { PriorityStarAggridComponent } from '../../../widgets/priority-star-aggrid/priority-star-aggrid.component';
import { AppState } from '../../../redux';
import { ResearchScreenActionTypes } from '../../../redux/actions/research-screen.actions';
import { ThreadListConfig } from '../../../pages/research/research.view-model';
import { IdHelperService } from '../../../services/id-helper.service';

export interface ExpandGroup {
    key: string;
    id: string;
    parent: ExpandGroup;
}

const DEFAULT_PAGE_SIZE = 100;

@Component({
    selector: 'tam-async-group-paging-grid',
    templateUrl: './async-group-paging-grid.component.html',
    styleUrls: ['./async-group-paging-grid.component.scss']
})

export class AsyncGroupPagingGridComponent implements OnInit, OnDestroy {
    @Input() config: ThreadListConfig;
    @Input() gridServerSideLayout;
    @Input() gridServerSideFeedback$;
    @Input() gridServerSideAction$;

    columnDefs: Array<ColDef>;
    gridOptions: GridOptions;
    columnDefsServerSide;
    gridOptionsServerSide;
    getRowNodeId;
    getChildCount;
    groupSortOrder;
    pinnedGridRowData;
    serverSidePinnedRowSubject$ = new Subject();

    private _destroySubscriptions: Array<Subscription> = [];
    private _gridApiServerSide;
    private _gridColumnApiServerSide;
    private _columnApi;
    private _sortInfo: any;
    private _previousSortInfo: any;
    private _expandGroups: ExpandGroup[] = [];

    private _allNoteGroupTypes = new Map();
    private _overlayNoRowsTemplate = '<span style=\'font-size: 20px;background-color:white;color:black\'>No Data Found</span>';
    private _gridServerSideSubject$ = new Subject();
    private _serverSidescrollTop = 0;
    private _rowSelectedIndexes: Set<number> = new Set();
    private _serverSideSorting = false;
    private _gridBodyViewport;

    constructor(
        private _store: Store<AppState>,
        private _fileHelperService: FileHelperService,
        private _changeDetectorRef: ChangeDetectorRef,
        private _datepipe: DatePipe,
        private _element: ElementRef,
    ) { }

    ngOnInit() {
        this.getRowNodeId = (data) => {
            return data.id || data.threadEntryType.name;
        };

        this.getChildCount = (data) => {
            return data ? data.childCount : undefined;
        };
        // Defining data for columns
        this.columnDefs = [
            {
                headerName: 'Sentiment',
                headerComponentParams: {
                    template:
                        '<image src="./assets/images/singlesvg/positive_negative.svg" style="width:16px;height:16px;"></image>'
                },
                valueGetter: (params) => {
                    if (params.data) {
                        return params.data.threadEntrySentiment;
                    }
                    return '';
                },
                headerClass: 'icon-header-style',
                cellRenderer: function (params) {
                    const imageElement = document.createElement('img');
                    imageElement.width = 13;
                    imageElement.height = 13;
                    if (params && params.value) {
                        if (params.value === 1) {
                            imageElement.src = './assets/images/singlesvg/positive-header.svg';
                            return imageElement;
                        } else if (params.value === -1) {
                            imageElement.src = './assets/images/singlesvg/negative-header.svg';
                            return imageElement;
                        } else {
                            return '';
                        }
                    }
                },
                colId: 'sentiment',
                menuTabs: [],
                width: 32,
                minWidth: 32,
                maxWidth: 32,
                sortable: false,
                resizable: false,
                cellStyle: {
                    'text-align': 'center',
                    'padding-left': '8px',
                    'padding-right': '8px',
                    'text-overflow': 'unset'
                }
            },
            {
                headerName: 'Attachments',
                headerComponentParams: {
                    template:
                        '<image src="./assets/images/singlesvg/attachment.svg" style="width:16px;height:16px;"></image>'
                },
                valueGetter: (params) => {
                    if (params.data) {
                        return params.data.threadEntryAttachments;
                    }
                },
                headerClass: 'icon-header-style',
                cellRenderer: (params) => {
                    const imageElement = document.createElement('img');
                    imageElement.width = 14;
                    imageElement.height = 14;
                    if (params && params.data && params.data.attachments) {
                        if (params.data.attachments.size > 1) {
                            imageElement.src = './assets/images/singlesvg/attachment.svg';
                            return imageElement;
                        } else if (params.data.attachments.size === 1) {
                            const extension = Array.from(params.data.attachments)[0][1].extension;
                            const iconFileName = this._fileHelperService.getIconFileName(extension);
                            imageElement.src = './assets/images/singlesvg/' + iconFileName;
                            return imageElement;
                        } else {
                            return '';
                        }
                    }
                },
                colId: 'attachments',
                menuTabs: [],
                width: 32,
                minWidth: 32,
                maxWidth: 32,
                sortable: false,
                resizable: false,
                cellStyle: {
                    'text-align': 'center',
                    'padding-left': '8px',
                    'padding-right': '8px',
                    'text-overflow': 'unset'
                }
            },
            {
                headerName: 'Entities',
                valueGetter: (params) => {
                    let entitiesName = '';
                    if (params.data && params.data.parentEntry && params.data.parentEntry.entities && params.data.parentEntry.entities.length > 0) {
                        params.data.parentEntry.entities.forEach(entity => {
                            entitiesName = entitiesName + entity.shortName + ', ';
                        });
                        return entitiesName.substring(0, entitiesName.length - 2);
                    }
                },
                tooltipValueGetter: (params) => {
                    return (params.value);
                },
                colId: 'entity',
                menuTabs: ['columnsMenuTab'],
                minWidth: 50,
                cellStyle: (params) => this._getGridCellStyle(params),
            },
            {
                headerName: 'Type',
                valueGetter: (params) => {
                    if (params.data && params.data.threadEntryType) {
                        return params.data.threadEntryType.name;
                    }
                    return '';
                },
                tooltipValueGetter: (params) => {
                    return (params.value);
                },
                field: 'entrytype',
                colId: 'entrytype',
                menuTabs: ['columnsMenuTab'],
                minWidth: 50,
                cellStyle: (params) => this._getGridCellStyle(params),
            },
            {
                headerName: 'Subject',
                valueGetter: (params) => {
                    if (params.data) {
                        return params.data.threadEntryCalculatedSubject;
                    }
                    return '';
                },
                tooltipValueGetter: (params) => {
                    return (params.value);
                },
                colId: 'title',
                menuTabs: ['columnsMenuTab'],
                minWidth: 100,
                cellStyle: (params) => this._getGridCellStyle(params),
            },
            {
                headerName: 'Source',
                valueGetter: (params) => {
                    if (params.data && params.data.threadEntrySource) {
                        return params.data.threadEntrySource.shortName;
                    }
                    return '';
                },
                tooltipValueGetter: (params) => {
                    return (params.value);
                },
                colId: 'source',
                menuTabs: ['columnsMenuTab'],
                minWidth: 50,
                cellStyle: (params) => this._getGridCellStyle(params),
            },
            {
                headerName: 'Display Date',
                valueGetter: (params) => {
                    return params.data ? params.data.displayDate : '';
                },
                cellRenderer: (data) => {
                    return data.value ? DateHelperWebService.getWeekdayByDate(data.value) + ' ' +
                        this._datepipe.transform(data.value, 'MM/dd/yyyy HH:mm') : '';
                },
                tooltipValueGetter: (params) => {
                    return (params.value);
                },
                colId: 'displayDate',
                menuTabs: ['columnsMenuTab'],
                minWidth: 80,
                sortingOrder: ['desc', 'asc'],
                sort: 'desc',
                cellStyle: (params) => this._getGridCellStyle(params),
            },
            {
                headerName: 'Sidenotes',
                headerComponentParams: {
                    template:
                        '<image src="./assets/images/singlesvg/sidenote.svg" style="width:13px;height:13px;margin-top:7.5px;"></image>'
                },
                valueGetter: (params) => {
                    if (!params.data) {
                        return '';
                    }
                    if (params.data.threadEntryParseByThread) {
                        if (params.data.parentEntry.totalNotesInThread > 1) {
                            return params.data.parentEntry.totalNotesInThread - 1;
                        }
                    } else {
                        const totalNotesInThread = params.data.threadEntryTotalNotesInThread;
                        if (totalNotesInThread > 1) {
                            const notePostionInThread = params.data.threadEntryThreadPosition + 1;
                            return notePostionInThread + '/' + totalNotesInThread;
                        }
                    }
                },
                headerClass: 'icon-header-style',
                colId: 'sidenotes',
                menuTabs: [],
                suppressSizeToFit: true,
                width: 48,
                minWidth: 48,
                maxWidth: 48,
                sortable: false,
                resizable: false,
                cellStyle: {
                    'text-align': 'center',
                    'padding-left': '8px',
                    'padding-right': '8px'
                }
            },
            {
                headerName: 'Last Modified Date',
                valueGetter: (params) => {
                    if (!params.data) {
                        return '';
                    }
                    return params.data.lastEditedDate;
                },
                cellRenderer: (data) => {
                    return data.value ? DateHelperWebService.getWeekdayByDate(data.value) + ' ' +
                        this._datepipe.transform(data.value, 'MM/dd/yyyy HH:mm') : '';
                },
                tooltipValueGetter: (params) => {
                    return (params.value);
                },
                hide: true,
                colId: 'lastModifiedDate',
                menuTabs: ['columnsMenuTab'],
                minWidth: 80,
                sortingOrder: ['desc', 'asc'],
                cellStyle: (params) => this._getGridCellStyle(params),
            },
            {
                headerName: 'Submitted Date',
                valueGetter: (params) => {
                    if (!params.data) {
                        return '';
                    }
                    return params.data.submittedDate;
                },
                cellRenderer: (data) => {
                    return data.value ? DateHelperWebService.getWeekdayByDate(data.value) + ' ' +
                        this._datepipe.transform(data.value, 'MM/dd/yyyy HH:mm') : '';
                },
                tooltipValueGetter: (params) => {
                    return (params.value);
                },
                hide: true,
                colId: 'submittedDate',
                menuTabs: ['columnsMenuTab'],
                minWidth: 80,
                sortingOrder: ['desc', 'asc'],
                cellStyle: (params) => this._getGridCellStyle(params),
            },
            {
                headerName: 'Submitter',
                valueGetter: 'data.threadEntrySubmitter.shortName',
                tooltipValueGetter: (params) => {
                    return (params.value);
                },
                colId: 'submitter',
                hide: true,
                menuTabs: ['columnsMenuTab'],
                minWidth: 60,
                cellStyle: (params) => this._getGridCellStyle(params),
            },
            {
                headerName: 'Priority',
                valueGetter: 'data.threadEntryPriority',
                cellRenderer: PriorityStarAggridComponent,
                colId: 'priority',
                hide: true,
                menuTabs: ['columnsMenuTab'],
                width: 70,
                sortable: false,
                resizable: false,
            }
        ];
        // not share with client-side grid, all attr(example:columnDefs) will add gridOptions
        this.gridOptions = {
            debug: false, // remove the logs
            defaultColDef: {
                menuTabs: ['columnsMenuTab'],
                resizable: true,
                sortable: true,
            },
            animateRows: true,
            suppressMultiSort: true,
            groupDisplayType: 'groupRows',
            serverSideSortingAlwaysResets: true,
            cacheBlockSize: DEFAULT_PAGE_SIZE,
            rowGroupPanelShow: 'always',
            colResizeDefault: 'shift',
            suppressCellFocus: true,
            suppressColumnVirtualisation: true,
            enableBrowserTooltips: true,
            enableCellChangeFlash: true,
            rowSelection: 'multiple', // set it for print function.
            sortingOrder: ['asc', 'desc'],
            maintainColumnOrder: true,
            suppressContextMenu: true,
            suppressDragLeaveHidesColumns: true,
            suppressRowGroupHidesColumns: true,
            overlayNoRowsTemplate: this._overlayNoRowsTemplate,
            rowMultiSelectWithClick: true
        };
        this._initGridInfo();
        this._initSubscriptions();
    }

    ngOnDestroy() {
        this._store.dispatch({
            prefix: this.config.keyInStore,
            type: this.config.clearGroupByNoteItemsAction,
        });
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
    }

    /**
     * If using grouping and groupDisplayType = 'groupRows', then the group row is not focusable. When navigating, the grouping row is skipped. So not use keydown and onCellKeyDown on the grid, use keydown listener
     */
    @HostListener('window:keydown', ['$event'])
    handleKeyDown(event: KeyboardEvent) {
        const activeEl = document.activeElement;
        // grid focus el may be body, cell, row, so if focus el is kendo dialog or input, the keyboard event will return.
        if (activeEl.nodeName === 'INPUT' || activeEl.nodeName === 'KENDO-DIALOG') {
            return;
        }
        // 'keyCode' is deprecatedts, so use event.key
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            let rowIndex;
            if (event.key === 'ArrowDown') { // down
                rowIndex = Math.max(...Array.from(this._rowSelectedIndexes));
                const totalCount = this._gridApiServerSide.getDisplayedRowCount();
                if (rowIndex + 1 >= totalCount) {
                    return;
                }
            } else if (event.key === 'ArrowUp') { // up
                rowIndex = Math.min(...Array.from(this._rowSelectedIndexes));
                if (rowIndex === 0) {
                    return;
                }
            }
            const row = this._gridApiServerSide.getDisplayedRowAtIndex(rowIndex);
            if (row) {
                this._onCellKeyDown({ ...row, event });
                const viewportRows = this._gridBodyViewport.clientHeight / row.rowHeight;
                const currentRow = row.rowIndex + 1;
                const scrollTopRows = currentRow + 1 - viewportRows; // currentRow must add a greater number, example 1 to kepp space for scroll for grid
                // need to reset grid body viewport scrollTop, because use groupDisplayType, the group row is skipped when key down/up. when we no not want skipped the group row, we must re-calcute grid body viewport scrollTop
                this._gridBodyViewport.scrollTop = scrollTopRows * row.rowHeight;
            }
        } else if (event.key === 'Enter') {
            const lastIndex = Array.from(this._rowSelectedIndexes)[this._rowSelectedIndexes.size - 1];
            const row = this._gridApiServerSide.getDisplayedRowAtIndex(lastIndex);
            if (row && row.group) {
                row.setExpanded(!row.expanded);
            }
        }
    }

    onGridReadyServerSide(params) {
        this._gridApiServerSide = params.api;
        this._gridColumnApiServerSide = params.columnApi;
        if (this._gridColumnApiServerSide) {
            this._gridColumnApiServerSide.setRowGroupColumns(['entrytype']);
        }

        this._rowSelectedIndexes.clear();
        this._destroySubscriptions.push(
            this._store.pipe(
                select(this.config.threadListItemSelector)
            ).subscribe(items => {
                this.gridServerSideFeedback$.next({
                    type: 'SET_THREAD_ENTRY_LIST',
                    payload: items
                });
            }),
            this.serverSidePinnedRowSubject$.subscribe((value) => {
                this._gridApiServerSide.forEachNode((node) => {
                    if (node.key === value) {
                        node.setExpanded(false);
                        this._rowSelectedIndexes.clear();
                        this._rowSelectedIndexes.add(node.rowIndex);
                        this.pinnedGridRowData = null;
                        this._serverSidescrollTop = null;
                        this._gridApiServerSide.ensureIndexVisible(node.rowIndex);
                        this._changeSelectStyle();
                    }
                });
            })
        );
        this._gridServerSideSubject$.next();
        this._gridBodyViewport = this._element.nativeElement.querySelector('.ag-body-viewport');
    }

    onPostProcessPopup(params) {
        if (params.type !== 'columnMenu') {
            return;
        }
        // set a fix height for popup column menu
        const ePopup = params.ePopup;
        ePopup.style.top = 34 + 'px';
    }

    onServerSideBodyScroll(event) {
        this._serverSidescrollTop = event.top;
        if (this._serverSidescrollTop === null) {
            return;
        }
        if (this._gridApiServerSide) {
            const index = Math.ceil(this._serverSidescrollTop / 28);
            const row = this._gridApiServerSide.getDisplayedRowAtIndex(index);
            if (row) {
                if (this._serverSidescrollTop === 0) {
                    this.pinnedGridRowData = null;
                } else {
                    if (row.expanded || row.parent.expanded) {
                        const data = _.cloneDeep(row.parent.data);
                        if (row.parent.data) {
                            this.pinnedGridRowData = data;
                        } else {
                            this.pinnedGridRowData = null;
                        }
                    } else {
                        this.pinnedGridRowData = null;
                    }
                }
            }
        }
    }

    onColumnRowGroupChanged(event) {
        if (event.columns.length === 0) {
            this.gridServerSideFeedback$.next({
                type: 'CHANGE_ROW_MODEL'
            });
        }
    }

    onServerSideRowSelected(event) {
        if (event.event.ctrlKey || event.event.metaKey || event.event.shiftKey) {
            if (this._rowSelectedIndexes.has(event.rowIndex)) {
                this._rowSelectedIndexes.delete(event.rowIndex);
            } else {
                this._rowSelectedIndexes.add(event.rowIndex);
            }
        } else {
            this._rowSelectedIndexes.clear();
            this._rowSelectedIndexes.add(event.rowIndex);
        }
        this._changeSelectStyle();
        if (event.data && event.data.id) {
            this.gridServerSideFeedback$.next({
                type: 'ROW_SELECTED',
                payload: event
            });
        }
    }

    onServerSideColumnVisible(e) {
        const agGridColumns = this._gridColumnApiServerSide.getColumnState();
        const columns = [];
        agGridColumns.forEach((column, index) => {
            columns.push(column);
        });
        // hide all column expect group not save store
        this.gridServerSideFeedback$.next({
            type: 'COLUMN_STATE',
            payload: columns
        });
        this._updateGroupRowByColumns(e.column);
        this._sizeColumnsToFit();
    }

    onRowGroupOpened(event) {
        const node: ExpandGroup = this._getParentNode(event.node);
        const index = this._expandGroups.findIndex(item => item.id === node.id);
        if (event.node.expanded) {
            // node.setExpanded(true) trigger the function
            if (index < 0) {
                this._expandGroups.push(node);
                this._serverSideSorting = false;
            }
        } else {
            if (index >= 0) {
                this._expandGroups.splice(index, 1);
            }
        }
        this._store.dispatch({
            prefix: this.config.keyInStore,
            type: this.config.setGridRowModelTypeAction,
            payload: {
                expandGroups: this._expandGroups
            }
        });

        this.config.events$.next({
            type: 'GRIDROWGROUPCHANGED'
        });
    }

    onServerSideColumnResized(e) {
        if (e.source === 'uiColumnDragged' && e.finished) {
            this.onServerSideColumnVisible(e);
        }
    }

    onServerSideColumnMoved(e) {
        if (e.source === 'uiColumnDragged') {
            this.onServerSideColumnVisible(e);
        }
    }

    onContextMenu(event) {
        if (!this._rowSelectedIndexes.has(event.rowIndex)) {
            const tepmNotes = [];
            // remove selected group row
            Array.from(this._rowSelectedIndexes.values()).forEach(index => {
                const row = this._gridApiServerSide.getDisplayedRowAtIndex(index);
                if (row && !row.group) {
                    tepmNotes.push(row);
                }
            });
            if (tepmNotes.length === 1 && !event.node.group) {
                this._rowSelectedIndexes.clear();
                this._rowSelectedIndexes.add(event.rowIndex);
            }
        }
        const notes = [];
        // remove selected group row
        Array.from(this._rowSelectedIndexes.values()).forEach(index => {
            const row = this._gridApiServerSide.getDisplayedRowAtIndex(index);
            if (row && !row.group) {
                notes.push(row);
            }
        });
        if (notes.length === 0) {
            if (!event.node.group) {
                this._rowSelectedIndexes.clear();
                this._rowSelectedIndexes.add(event.rowIndex);
                notes.push(event.node);
            }
        } else {
            this._rowSelectedIndexes.clear();
            notes.forEach((item) => {
                this._rowSelectedIndexes.add(item.rowIndex);
            });
        }
        this._changeSelectStyle();
        if (notes.length > 0) {
            this.gridServerSideFeedback$.next({
                type: 'ROW_CONTEXT_MENU',
                payload: event,
                notes: notes
            });
        }
    }

    onServerSideRowDoubleClicked(event) {
        if (event.node.group) {
            return;
        }
        this.gridServerSideFeedback$.next({
            type: 'ROW_DOUBLE_CLICKED',
            payload: event
        });
    }

    suppressDefaultContextMenu(event) {
        // agGrid bug, we need to handle this
        event.preventDefault();
        event.stopPropagation();
    }

    onSortChanged(e) {
        const columnState = e.columnApi.getColumnState();
        const sortModel = columnState
            .filter(column => column.sort)
            .map(column => ({ colId: column.colId, sort: column.sort }));

        if (sortModel && sortModel.length > 0) {
            const sort = sortModel;
            this._previousSortInfo = _.cloneDeep(this._sortInfo);
            this._sortInfo.sortBy = sort[0].colId;
            this._sortInfo.sortOrder = sort[0].sort;
            if (sort[0].colId === 'entrytype') {
                this.groupSortOrder = sort[0].sort;
                this._saveStoreGroupSort();
            }
            this._changeSort();
        }
    }

    setSortByType(order) {
        this.groupSortOrder = order;
        if (this._sortInfo.sortBy === 'entrytype') {
            const sorts = [{
                colId: this._sortInfo.sortBy,
                sort: order
            }];
            this._gridColumnApiServerSide.applyColumnState({ state: sorts });
        } else {
            this._gridServerSideSubject$.next();
        }
        this._saveStoreGroupSort();
    }

    private _changeSort() {
        const currSortBy = this._sortInfo && this._sortInfo.sortBy === 'entrytype';
        const preSortBy = this._previousSortInfo && this._previousSortInfo.sortBy === 'entrytype';
        this._serverSideSorting = currSortBy && preSortBy && this._sortInfo.sortOrder === this._previousSortInfo.sortOrder;
    }

    private _sizeColumnsToFit() {
        if (this._gridApiServerSide) {
            this._gridApiServerSide.sizeColumnsToFit();
            this._changeDetectorRef.detectChanges();
        }
    }

    private _saveStoreGroupSort() {
        this._store.dispatch({
            prefix: this.config.keyInStore,
            type: this.config.setGridRowModelTypeAction,
            payload: {
                groupSortColumns: [{
                    sortBy: 'entrytype',
                    sortOrder: this.groupSortOrder
                }]
            }
        });
    }

    private _reload() {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
        this._initGridInfo();
        this._initSubscriptions();
        this.onGridReadyServerSide({
            api: this._gridApiServerSide,
            columnApi: this._gridColumnApiServerSide
        });
    }

    private _getParentIds(node) {
        const ids = [node.key];
        if (node.parent && node.parent.key) {
            ids.push(this._getParentIds(node.parent));
        }
        return ids.join(',');
    }

    private _setLoadingStatus() {
        setTimeout(() => {
            this.gridServerSideFeedback$.next({
                type: 'SET_LOADING_STATUS',
                payload: false
            });
        }, 0);
    }

    private _setExpandGroups() {
        setTimeout(() => {
            this._expandGroups.forEach(item => {
                if (this.gridOptions.api) {
                    const note = this.gridOptions.api.getRowNode(item.key);
                    if (note) {
                        note.setExpanded(true);
                    }
                }
            });
        }, 0);
    }

    private _getParentNode(node) {
        const result: ExpandGroup = {
            key: null,
            parent: null,
            id: null
        };
        result.id = this._getParentIds(node);
        result.key = node.key;
        if (node.parent.key) {
            result.parent = this._getParentNode(node.parent);
        }
        return result;
    }

    private _initGridInfo() {
        this._serverSidescrollTop = 0;
        this._serverSideSorting = false;
        this._rowSelectedIndexes.clear();
        if (this.gridServerSideLayout.expandGroups) {
            this._expandGroups = _.cloneDeep(this.gridServerSideLayout.expandGroups);
        }
        if (this.gridServerSideLayout.groupSortColumns && this.gridServerSideLayout.groupSortColumns[0]) {
            this.groupSortOrder = this.gridServerSideLayout.groupSortColumns[0].sortOrder;
        } else {
            this.groupSortOrder = 'asc';
        }
        this._store.pipe(
            select(this.config.gridInfoSelector),
            take(1)
        ).subscribe(columnState => {
            if (columnState && columnState.length > 0 && JSON.stringify(columnState) !== '{}') {
                const columns = JSON.parse(columnState);
                const tempColumns = [];
                columns.forEach(item => {
                    const index = this.columnDefs.findIndex(column => column.colId === item.colId);
                    if (index !== -1) {
                        const tempItem = Object.assign(this.columnDefs[index], item);
                        tempColumns.push(tempItem);

                    }
                });
                this.columnDefs = tempColumns;
            }
        });
        this._store.pipe(
            select(this.config.sortInfoSelector),
            take(1)
        ).subscribe(sortInfo => {
            const tempSort = {
                sortBy: 'displayDate',
                sortOrder: 'desc'
            };
            if (sortInfo && JSON.stringify(sortInfo) !== '{}') {
                tempSort.sortBy = sortInfo.sortBy;
                tempSort.sortOrder = sortInfo.sortOrder;
                if (sortInfo.sortBy === 'entrytype') {
                    this.groupSortOrder = sortInfo.sortOrder;
                }
            }
            this._sortInfo = tempSort;
            this.columnDefs.forEach(item => {
                if (item.colId === this._sortInfo.sortBy) {
                    item.sort = this._sortInfo.sortOrder;
                } else {
                    item.sort = null;
                }
            });
        });
    }

    private _initSubscriptions() {
        this._destroySubscriptions.push(
            this.gridServerSideAction$.subscribe((action) => {
                this._gridServerSideAction(action);
            }),
            this._gridServerSideSubject$.subscribe(() => {
                this._store.dispatch({
                    prefix: this.config.keyInStore,
                    type: this.config.clearGroupByNoteItemsAction,
                });
                this._setServerSideDatasource();
            })
        );
    }

    private _gridServerSideAction(action) {
        if (action.type === 'WINDOW_RESIZE') {
            this._sizeColumnsToFit();
        } else if (action.type === 'FOCUS') {
            // get the index of last selected item
            let nextIndex = 0;
            Array.from(this._rowSelectedIndexes.values()).forEach(index => {
                if (index > nextIndex) {
                    nextIndex = index;
                }
            });
            this._gridApiServerSide.setFocusedCell(nextIndex, this.columnDefs[0].colId);
        } else if (action.type === 'TAB_CLICK') {
            this._gridApiServerSide.sizeColumnsToFit();
        } else if (action.type === 'DELETE_ATTACHMENT_SUCCESS') {
            const msg = action.payload;
            if (msg.indexOf(DELETE_ATTACHMENT_SUCCESS) > -1) {
                // TODO: Need to improve to pass the accurate value by object
                const attachId = msg.substring(msg.lastIndexOf('-') + 1);
                this._gridApiServerSide.getSelectedNodes().forEach(node => {
                    if (node.data.attachments.has(attachId)) {
                        node.data.attachments.delete(attachId);
                    }
                });
                const params = {
                    rowNodes: this._gridApiServerSide.getSelectedNodes(),
                    force: true
                };
                this._gridApiServerSide.refreshCells(params);
            }
        } else if (action.type === ResearchScreenActionTypes.SET_LAYOUT_COLLAPSE) {
            // Fixed for TAM-23366： The columns cannot auto-fit after collapsing Refine By panel
            // TODO: Need to figurte out a better solution to fix the issue.,
            setTimeout(() => {
                this._gridApiServerSide.sizeColumnsToFit();
            }, 1000);
        } else if (action.type === DELETE_SIDENOTE_SUCCESS) {
            const params = {
                rowNodes: this._gridApiServerSide.getSelectedNodes(),
                force: true
            };
            this._gridApiServerSide.refreshCells(params);
            this._changeDetectorRef.detectChanges();
        } else if (action.type === 'RELOAD') {
            this._reload();
        }
    }

    private _changeSelectStyle() {
        if (this._gridApiServerSide) {
            this._gridApiServerSide.forEachNode((node) => {
                if (this._rowSelectedIndexes.has(node.rowIndex)) {
                    node.setSelected(true);
                } else {
                    node.setSelected(false);
                }
            });
        }
        if (this._changeDetectorRef && !this._changeDetectorRef['destroyed']) {
            this._changeDetectorRef.detectChanges();
        }
    }

    private _setServerSideDatasource() {
        const datasource = this._serverSideDatasource();
        if (this._gridApiServerSide) {
            this._gridApiServerSide.setServerSideDatasource(datasource);
        }
    }

    private _fakeServer(request) {
        if (request.startRow === undefined) {
            request.startRow = 0;
        }
        const allGroupTypes = this._allNoteGroupTypes.get(this.config.keyInStore);
        let currGroupType;
        if (allGroupTypes) {
            currGroupType = allGroupTypes.find(item => item.value === request.groupKeys[0]);
        }
        const sortInfo = {
            sortBy: this._sortInfo.sortBy,
            sortOrder: this._sortInfo.sortOrder,
        };
        // resolve destory console error
        if (this._changeDetectorRef['destroyed']) {
            const observable = new Observable(subscriber => {
                subscriber.next();
                subscriber.complete();
            });
            return observable.pipe(
                map(() => {
                    return {
                        success: true,
                        rows: [],
                        lastRow: 0,
                        destory: true
                    };
                })
            );
        }
        if (request.groupKeys.length === 0) {
            if (request.startRow === 0 && !request.notSendRequest) {
                this.gridServerSideFeedback$.next({
                    type: 'LOAD_GRID_GROUP_DATA',
                    payload: {
                        pageIndex: 1,
                        pageSize: DEFAULT_PAGE_SIZE,
                        groups: JSON.stringify(['noteType']),
                        groupSortOrder: this.groupSortOrder,
                    },
                    sortInfo: sortInfo
                });
                return this._store.pipe(
                    select(this.config.threadListGroupItemSelector),
                    skip(1),
                    take(1),
                    map((data) => {
                        this._allNoteGroupTypes.set(this.config.keyInStore, data);
                        let arr = [];
                        if (data) {
                            arr = data.map((item) => ({
                                threadEntryType: {
                                    name: item.value
                                },
                                childCount: item.size
                            }));
                        }
                        this.gridServerSideFeedback$.next({
                            type: 'LOAD_GRID_GROUP_NO_DATA',
                            payload: arr.length
                        });
                        return {
                            success: true,
                            rows: arr.slice(request.startRow, request.endRow),
                            lastRow: this._getLastRowIndex(request, arr.length)
                        };
                    })
                );
            } else {
                const observable = new Observable(subscriber => {
                    subscriber.next();
                    subscriber.complete();
                });
                return observable.pipe(
                    map(() => {
                        let arr = [];
                        if (allGroupTypes) {
                            arr = allGroupTypes.map((item) => ({
                                threadEntryType: {
                                    name: item.value
                                },
                                childCount: item.size
                            }));
                        }
                        return {
                            success: true,
                            rows: arr.slice(request.startRow, request.endRow),
                            lastRow: this._getLastRowIndex(request, allGroupTypes ? allGroupTypes.length : 0),
                        };
                    })
                );
            }
        }
        let groupId;
        const requestId = IdHelperService.createGUID();
        if (currGroupType && currGroupType['original-value']) {
            groupId = currGroupType['original-value'];
            // when group sort is asc and sort by type, so not send request, should selected all data from store
            if (request.startRow === 0 && request.notSendRequest) {
                return this._store.pipe(
                    select(this.config.threadListGroupItemsSelector),
                    filter(data => {
                        return !groupId || (data && data[groupId]);
                    }),
                    take(1),
                    map((data) => {
                        const arr = data[groupId] || [];
                        return {
                            success: true,
                            rows: arr.slice(request.startRow, request.endRow),
                            lastRow: this._getLastRowIndex(request, currGroupType.size),
                        };
                    })
                );
            }
            this.gridServerSideFeedback$.next({
                type: 'LOAD_GRID_GROUP_DATA',
                payload: {
                    requestId: requestId,
                    groupId: groupId,
                    pageIndex: request.endRow / DEFAULT_PAGE_SIZE,
                    pageSize: DEFAULT_PAGE_SIZE,
                    groups: JSON.stringify(['noteType']),
                    groupSortOrder: this.groupSortOrder,
                    groupFilters: JSON.stringify({ 'noteType': groupId }),
                },
                sortInfo: sortInfo
            });
        }
        return this._store.pipe(
            select(this.config.threadListGroupItemsSelector),
            filter(data => {
                // todo use prefix and groupId
                /**
                    * Two requests are sent. The timing of the return result of the request is uncertain,
                    * which may cause two subscriptions to go to the same return result at the same time
                    * open one group at the same time scroll other group to next page
                    * open two group
                **/
                return !groupId || (data && data[groupId] && data.requestIds.indexOf(requestId) !== -1);
            }),
            take(1),
            map((data) => {
                const arr = data[groupId] || [];
                return {
                    success: true,
                    rows: arr.slice(request.startRow, request.endRow),
                    lastRow: this._getLastRowIndex(request, currGroupType.size),
                };
            })
        );
    }

    private _getLastRowIndex(request, size) {
        if (!size || size === 0) {
            return null;
        }
        return size <= request.endRow ? size : -1;
    }

    private _serverSideDatasource() {
        return {
            getRows: (params) => {
                if (this._serverSideSorting && params.request.startRow === 0) {
                    params.request.notSendRequest = true;
                } else {
                    delete params.request.notSendRequest;
                }
                this._fakeServer(params.request).subscribe((response) => {
                    if (response.success) {
                        params.successCallback(response.rows, response.lastRow);
                        if (response['destory']) {
                            return;
                        }
                        if (params.request.groupKeys.length === 0) {
                            setTimeout(() => {
                                this._setExpandGroups();
                                if (params.request.startRow === 0) {
                                    this._setLoadingStatus();
                                    this._rowSelectedIndexes.clear();
                                    this._changeSelectStyle();
                                    this._sizeColumnsToFit();
                                }
                            });
                        }
                    } else {
                        params.failCallback();
                    }
                });
            }
        };
    }

    private _onCellKeyDown(rowNode) {
        const selectedRow = (nextIndex) => {
            this._rowSelectedIndexes.clear();
            this._rowSelectedIndexes.add(nextIndex);
            this._changeSelectStyle();
            const row = this._gridApiServerSide.getDisplayedRowAtIndex(nextIndex);
            this._gridApiServerSide.setFocusedCell(nextIndex, this.columnDefs[0].colId);
            if (row && row.data) {
                this.gridServerSideFeedback$.next({
                    type: 'ROW_KEYDOWN',
                    payload: row
                });
            }
        };
        const count = this._gridApiServerSide.getDisplayedRowCount();
        if (rowNode.event.keyCode === 40) { // down
            let nextIndex = 0;
            Array.from(this._rowSelectedIndexes.values()).forEach(index => {
                if (index > nextIndex) {
                    nextIndex = index;
                }
            });
            if (++nextIndex < count) {
                selectedRow(nextIndex);
            }
        } else if (rowNode.event.keyCode === 38) { // up
            const indexArr = Array.from(this._rowSelectedIndexes.values());
            let nextIndex = indexArr[0];
            indexArr.forEach(index => {
                if (index < nextIndex) {
                    nextIndex = index;
                }
            });
            if (--nextIndex > -1) {
                selectedRow(nextIndex);
            }
        }
    }

    private _getGridCellStyle(params) {
        const cellStyleObj = {};
        const leftPinColumns = params.columnApi.getDisplayedLeftColumns();
        if (leftPinColumns.length > 0) {
            if (!params.node.group && params.column.left === 0 && params.node.level !== 0 && params.column.pinned === 'left') {
                const paddingLeft = params.node.level * 30;
                cellStyleObj['padding-left'] = `${paddingLeft}px`;
            }
        } else {
            if (!params.node.group && params.column.left === 0 && params.node.level !== 0) {
                const paddingLeft = params.node.level * 30;
                cellStyleObj['padding-left'] = `${paddingLeft}px`;
            }
        }
        return cellStyleObj;
    }

    private _updateGroupRowByColumns(column?) {
        // set column visible, pinned column, drag column, redraw rows for indented rows
        if (column && (column.left === 0 || column.oldLeft === 0 || !column.visible)) {
            this._gridApiServerSide.redrawRows();
        }
    }
}
